/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "b120610180fb97a4797274e8865acf5536042d51";
